import type { OrderResponse } from '@/queries/useCart';
import { useTranslation } from 'react-i18next';
import { ReceiptHeader } from './ReceiptHeader';
import { ReceiptItems } from './ReceiptItems';
import { ReceiptTotals } from './ReceiptTotals';

interface OrderReceiptProps {
  order: OrderResponse['data'];
  restaurantName?: string;
  branchName?: string;
  branchAddress?: string;
  branchPhone?: string;
  tableNumber?: string | null;
}

export function OrderReceipt({
  order,
  restaurantName = 'Restaurant',
  branchName,
  branchAddress,
  branchPhone,
  tableNumber,
}: OrderReceiptProps) {
  const { i18n } = useTranslation('customer');
  const isRTL = i18n.language === 'ar';

  return (
    <div
      className="w-full max-w-md mx-auto bg-white dark:bg-gray-900 p-6 print:p-4 print:max-w-none"
      dir={isRTL ? 'rtl' : 'ltr'}
    >
      {/* Receipt Container - Thermal printer aesthetic */}
      <div className="font-mono text-sm space-y-4 print:space-y-2">
        {/* Header */}
        <ReceiptHeader
          restaurantName={restaurantName}
          branchName={branchName}
          branchAddress={branchAddress}
          branchPhone={branchPhone}
          tableNumber={tableNumber}
          orderNumber={order.orderId}
          orderTime={new Date()}
        />

        {/* Divider */}
        <div className="border-t border-dashed border-gray-400 my-4" />

        {/* Items */}
        <ReceiptItems items={order.items} />

        {/* Divider */}
        <div className="border-t border-dashed border-gray-400 my-4" />

        {/* Totals */}
        <ReceiptTotals order={order} />
      </div>
    </div>
  );
}












